export const UserActions = {
    ALL_USERS_UPDATE_SUCCESS: "ALL_USERS_UPDATE_SUCCESS",
    USER_LIST_UPDATE_FAILED: "USER_LIST_UPDATE_FAILED",
    CHANGE_TOTAL_NUMBER_OF_PAGES_USER: "CHANGE_TOTAL_NUMBER_OF_PAGES_USER",
    CHANGE_PAGE_USER: "CHANGE_PAGE_USER",
    CHANGE_TOTAL_USER: "CHANGE_TOTAL_USER",
    UPDATE_GROUPS: "UPDATE_GROUPS",
    ADD_GROUPS: "ADD_GROUPS",
    ADD_ORGANISATIONS: "ADD_ORGANISATIONS",
    UPDATE_ORGANISATIONS: "UPDATE_ORGANISATIONS",
    DELETE_ORGANISATION: "DELETE_ORGANISATION",
}